import { useOutletContext } from 'react-router-dom'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

import { useFilter, useNewlyAddedFilters } from '../context'

export const AgreementStatusFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('agreementStatus')
  const { newlyAddedFilters } = useNewlyAddedFilters()

  if (!reviewProcess.agreementsConfiguration.enabled) return null

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.agreements.filters.status.title')}
      value={value}
      options={[
        {
          label: i18n.t('performance_process.agreements.filters.signed'),
          value: 'hassignedagreement',
        },
        {
          label: i18n.t('performance_process.agreements.filters.pending'),
          value: 'haspendingagreement',
        },
        {
          label: i18n.t('performance_process.agreements.filters.not_initiated'),
          value: 'notinitiated',
        },
      ]}
      onValueChange={setValue}
      defaultOpen={newlyAddedFilters.includes('agreementStatus')}
    />
  )
}
